// @flow
import {
    HIKE_LIST,
    HIKE_LIST_SUCCESS,
    HIKE_LIST_FAILED,

} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

const INIT_STATE = {
    user: getLoggedInUser(),
    loading: false,
};

type HikeAction = { type: string, payload: {} | string };
type State = { user?: {} | null, loading?: boolean, +value ?: boolean };

const Hike = (state: State = INIT_STATE, action: HikeAction) => {
    switch (action.type) {
        case HIKE_LIST:
            return { ...state, listloading: true };
        case HIKE_LIST_SUCCESS:
            return { ...state, hike: action.payload, listloading: false, error: null };
        case HIKE_LIST_FAILED:
            return { ...state, error: action.payload, loading: false };
    
        default:
            return { ...state };
    }
};

export default Hike;
